import React, { useEffect, useState, useMemo } from 'react';

import { ClipboardCopyIcon } from '@heroicons/react/solid';
import { useCurrentOrganization } from '../store/organization';
import { generateJourneyShareUrl } from '../utils/journey';
import { apiGetJourneyThumbnailUrl } from '../utils/journeyApi';
import { useNotificationMessage } from '../common/notification/message.hook';
import { isSafari } from 'react-device-detect';
import copy from 'copy-to-clipboard';

export async function CopyToClipboardWithStyles(elementId) {
  const element = document.getElementById(elementId);

  if (!isSafari) {
    // eslint-disable-next-line no-undef
    const clipboardItem = new ClipboardItem({ 'text/html': new Blob([element.outerHTML], { type: 'text/html' }) });
    await navigator.clipboard.write([clipboardItem]);
    return;
  }

  copy(element.outerHTML, { format: 'text/html' });
}

function JourneyShareThumbnailCode({ codeId, email, journey, thumbnail }) {
  const { currentOrganization } = useCurrentOrganization();
  const [thumbnailUrl, setThumbnailUrl] = useState(thumbnail);
  const { setSuccessNotification } = useNotificationMessage();

  const shareUrl = useMemo(() => {
    return generateJourneyShareUrl(currentOrganization, journey);
  }, [currentOrganization, journey]);

  useEffect(() => {
    if (!thumbnailUrl) {
      apiGetJourneyThumbnailUrl(journey.uuid, {
        ...(email && { email: email }),
      }).then((response) => {
        if (response.thumbnail_url) {
          setThumbnailUrl(response.thumbnail_url);
        } else {
          setThumbnailUrl(null);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shareUrl ? (
    <div className='flex flex-col space-y-4 text-secondary'>
      <div className='flex items-center'>
        <button
          type='button'
          className='btn secondary-btn flex items-center space-x-2'
          onClick={() => {
            CopyToClipboardWithStyles(codeId);
            setSuccessNotification('Thumbnail link is copied to your clipboard!');
          }}
        >
          <ClipboardCopyIcon className='w-4 h-4' />
          <div className='text-sm'>Copy Thumbnail Link</div>
        </button>
      </div>
      <div id={codeId} className='flex flex-col space-y-2'>
        <a href={shareUrl}>
          <img src={thumbnailUrl} width='480' height='auto' alt='Journey Thumbnail' />
        </a>
        <a href={shareUrl}>View Journey: {journey.name}</a>
      </div>
    </div>
  ) : (
    <div className='text-bedrock-red text-sm'>
      You have no active link to share. Please create a link from the 'Share Links' tab so we can generate the link for
      you.
    </div>
  );
}

JourneyShareThumbnailCode.defaultProps = {
  codeId: 'journey-thumbnail-code',
};

export default JourneyShareThumbnailCode;
